import {HttpClient,HttpErrorResponse,HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {SERVER_API_URL} from 'src/app/app.constants';
import {BrokerCertificateService} from 'src/app/client/broker-get-certificate/broker-get-certificate.service';
import {Principal} from 'src/app/core/auth/principal.service';
import {StateStorageService} from 'src/app/core/auth/state-storage.service';
import {LoginOtp} from 'src/app/shared/model/login-otp.modal';
import {INotification} from 'src/app/shared/model/notification.model';
import {NotificationService} from 'src/app/shared/notification.service';
import {AuthServerProvider} from '../auth/auth-session.service';



@Injectable({ providedIn: 'root' })
export class LoginService {


    private serverUrl = SERVER_API_URL + 'socket'
    isLoaded: boolean = false;
    isCustomSocketOpened = false;
    private stompClient;
    public messages: INotification[] = [];
    
   public  notificationCount:number;
    constructor(
        private principal: Principal,
        private authServerProvider: AuthServerProvider,
        private jhiAlertService: JhiAlertService,
        private stateStorageService: StateStorageService,
        private router: Router,
        private notificationService:NotificationService,
        private brokerCertificateService: BrokerCertificateService,
        private http:HttpClient
    ) {
      notificationService.setLoginService(this);
    }
     

    login(credentials, callback?) {
        const cb = callback || function() {};

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(
              data => {
                if(data&&data.body&&data.body.twoFactorEnabled==true) {
                  resolve(data);
                  return data;
                } else {
                  localStorage.setItem('currentUser',JSON.stringify(data.body));
                  this.principal.identity(true).then(account => {
                    resolve(data);
                    this.initializeWebSocketConnection();
                    this.notificationMessagesAndCount();
                        
                    // this.principal.getStorageScope();
                  });
                  return cb();
                }
                },
                err => {
                  this.processLogout();
                  reject(err);
                  this.router.navigate(['/login'])
                  return cb(err);
                }
            );
        });
    }

    logout() {
        this.authServerProvider.logout().subscribe((res: HttpErrorResponse) => {
            this.notificationService.disconnectSocket();
            this.messages = [];
            // this.jhiAlertService.error(res.error.message, null, null)
        });

        // result.subscribe((res: HttpResponse<IPolicyMySuffix>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError(res));
        this.processLogout();
       
 
   }
   
  processLogout() {
    this.stateStorageService.resetCertificateDTO();
    this.stateStorageService.resetBulkCertificateDTO();
    this.stateStorageService.resetTypeOfClient();
    this.stateStorageService.resetClientDTO();

    localStorage.removeItem('cargoDetail');
    localStorage.removeItem('shippingDetail');
    localStorage.removeItem('tradeDetails');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('profileId');

    this.principal.authenticate(null);
     
    this.brokerCertificateService.clientDto=null;
    this.brokerCertificateService.policyCurrency=null;
    this.brokerCertificateService.policyId=null;
    // this.principal.isStorageScope=false;
    this.router.navigate([ '/login' ]);
  }

    initializeWebSocketConnection() {
        this.stompClient = this.notificationService.connectSocket();
        let that = this;
        this.stompClient.connect({}, function (frame) {
          that.isLoaded = true;
          that.openGlobalSocket()
        });
      }
    
      openGlobalSocket() {
    
        //if (this.principal.userIdentity.authorities[0] === 'BROKER' || this.principal.userIdentity.authorities[0] === 'BROKER_STAFF') {
          //url == '/socket-publisher"'
        this.subscribeOpenSocket("/socket-publisher/"+this.principal.userIdentity.id)
        // console.log(this.principal);
        
        //}
      }
    
      subscribeOpenSocket(url){
        this.stompClient.subscribe(url, (message) => {
          this.handleResult(message);
        });
      }
    
      /* openSocket() {
        if (this.isLoaded) {
          this.isCustomSocketOpened = true;
          this.stompClient.subscribe("/socket-publisher/"+this.userForm.value.fromId, (message) => {
            this.handleResult(message);
          });
        }
      } */
    
      handleResult(message) {
        if (message.body) {
           let notification = JSON.parse(message.body)
            this.messages.unshift(notification);
            this.notificationCount = notification.count;
            this.getMessages();
        }
      } 

      disconnectSocket(){
          this.stompClient.disconnect();
      }
      notificationMessagesAndCount(){
        this.notificationService.getCountByUser().subscribe(res=>{
          this.notificationCount = res.body;
          
      })
      this.getMessages();
      }
      getMessages(){
        this.notificationService.findTop10ByLogInUser().subscribe( response => {
          this.messages = response.body;
      })
      }
      getLogInUserProfileId():any{
       let url = 'api/user-profile';
       return this.authServerProvider.query(url);

      }

    
     validateSpotClientEmailId(userName:string ) {
        const loginData = {
            'j_username': userName,
        }
        let url = SERVER_API_URL +"api/authenticate-email"
        return this.http.post<any>(url, loginData, { observe: 'response' });
  }


  processLogin(data) {
    localStorage.setItem('currentUser',JSON.stringify(data));
    this.principal.identity(true).then(account => {
      this.initializeWebSocketConnection();
      this.notificationMessagesAndCount();
      // this.principal.getStorageScope();
    });
  }

  
  resendOtp(loginOtp: LoginOtp) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json').append('X-TDIS-KEY','oZP8ZqWxCY65ndFAh0kk3b1H5qgrVbwA');
    return this.http.post<any>(SERVER_API_URL + 'api/otp/resend-otp', loginOtp, { headers });
    // return this.http.post<any>(SERVER_API_URL + 'api/otp/resend-otp', loginOtp, { observe: 'response' });
    // return this.authServerProvider.resendOtp(loginOtp);
  }
  
  verifyOtp(loginOtp: LoginOtp) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json').append('X-TDIS-KEY','oZP8ZqWxCY65ndFAh0kk3b1H5qgrVbwA');
    return this.http.post(SERVER_API_URL + 'api/otp/verify-otp', loginOtp, { headers });
  }

  // check reset key time after forgot password 
  checkPasswordResetKey(key:any) {
    return this.http.post(SERVER_API_URL + 'api/resetLink' , { token: key.trim() }, { observe: 'response' });
  }
}


